import React from 'react';

const Clips = () => {
    return (
        <div></div>
    )
}

export default Clips;


// WEBPACK FOOTER //
// ./src/components/Main/About/Clips.js